<template>
  <div class="template-auth row mx-1 mx-lg-5">
    <div class="slot-wrapper col-lg-4 py-5">
      <slot />
      <!-- <div class="small text-secondary mt-5 ms-4">
        Este site é protegido por reCAPTCHA e a
        <a target="_blank" href="https://policies.google.com/privacy"
          >Política de Privacidade</a
        >
        e os
        <a target="_blank" href="https://policies.google.com/terms"
          >Termos de Serviço</a
        >
        do Google se aplicam.
      </div> -->
    </div>

    <div
      class="col-lg-8 d-none d-lg-flex align-items-center justify-content-center"
    >
      <img
        src="@/assets/images/template/new-computer_d.png"
        class="img-fluid"
      />
    </div>
    <!-- <div class="img-bg bg-dark"></div>
    <div class="flex-fill"></div>
    <div class="flex-fill"></div> -->
  </div>
</template>

<style lang="scss" scoped>
.template-auth {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  background-image: url("../assets/images/bg/signin.jpg");
  background-position: center;
  background-size: cover;

  @media screen and (max-width: 991px) {
    flex-direction: column;

    justify-content: center;
    background: #000;
    .slot-wrapper {
      margin: 0 auto;
      width: 80%;
    }

    .img-bg {
      position: absolute;
      z-index: -1;

      width: 100%;
      height: 100vh;

      opacity: 0.1;
    }
  }
}
</style>
